import React from 'react';
import styled from 'styled-components';

const myWeather = {
  "consolidated_weather": [
    {
      "id": 5965763787620352,
      "weather_state_name": "Heavy Cloud",
      "weather_state_abbr": "hc",
      "wind_direction_compass": "W",
      "created": "2020-01-06T18:16:44.497515Z",
      "applicable_date": "2020-01-06",
      "min_temp": 0.66,
      "max_temp": 7.19,
      "the_temp": 5.91,
      "wind_speed": 9.049944524555263,
      "wind_direction": 266.6799949948212,
      "air_pressure": 1014,
      "humidity": 65,
      "visibility": 16.32870287520878,
      "predictability": 71
    },
  ],
  "title": "New York",
}

  const WeatherWrapper = styled.div`
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-content: center;
  `

  const Top = styled.div`
    padding: 1.5rem 0;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `

    const Description = styled.h3`
      font-size: 1.2em;
      font-weight: 400;
      letter-spacing: 0.15em;
      color: #373D3F;
    `
    const City = styled.h5`
      color: #8C979A;
      font-size: 0.8em;
      font-weight: 300;
      line-height: 100%;
    `

  const Mid = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content:space-around;
    align-items: flex-start;
  `
    const Icon = styled.img`
      height: 50px;
      width: 50px;
    `
    const BoxTemp = styled.div`
      height: 50px;
      width: 50px;

      display: flex;
      justify-content: center;
      align-items: center;
    `

      const Temperature = styled.h2`
        font-weight: 300;
        font-size: 1.5em;
      `

  const Bot = styled.div`
    padding: 1.7rem 2.1rem;
    display: flex;
    flex-direction: column;
    justify-content:space-around;
    align-items: center;
  `
    const Info = styled.div`
      width: 100%; 
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-content: center;
    `

      const Condition = styled.h5`
        flex-grow: 1;
        font-weight: 400;
        font-size: 1em;
        color: #555F61;
      `
      const Measure = styled.h5`
        font-weight: 300;
        font-size: 1em;
      `

export default function Weather() {
  const [weather, setWeather] = React.useState(myWeather)


  React.useEffect(() => {
    function fetchWeather() {
      fetch('https://cors-anywhere.herokuapp.com/https://www.metaweather.com/api/location/2459115/')
        .then(res => res.json())
        .then(data => setWeather(data))
    }
    const interval = setInterval(() => {
      fetchWeather()
    }, 60000)
    fetchWeather()
    return () => clearInterval(interval)
  }, [])

  return (
    <WeatherWrapper>
      <Top>
        <Description>{weather.consolidated_weather[0].weather_state_name}</Description>
        <City>{weather.title}</City>
      </Top>
      <Mid>
        <Icon src={`https://www.metaweather.com/static/img/weather/${weather.consolidated_weather[0].weather_state_abbr}.svg`}/>
        <BoxTemp><Temperature>{Math.floor((weather.consolidated_weather[0].the_temp * 9 / 5) + 32)}°</Temperature></BoxTemp>
      </Mid>
      <Bot>
        <Info><Condition>Min/Max</Condition><Measure>{Math.floor((weather.consolidated_weather[0].min_temp * 9 / 5) + 32)}°/{Math.floor((weather.consolidated_weather[0].max_temp * 9 / 5) + 32)}°</Measure></Info>
        <Info><Condition>Humidity</Condition><Measure>{weather.consolidated_weather[0].humidity}</Measure></Info>
        <Info><Condition>Wind</Condition><Measure>{Math.floor(weather.consolidated_weather[0].wind_speed)}mph</Measure></Info>
      </Bot>
    </WeatherWrapper>
  )
}